<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem>媒体发布</BreadcrumbItem>
        <BreadcrumbItem>资源库</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">


      <ul class='conheadRight'>
        <i-button type="error" @click='removeAll' style='margin-right:10px;' v-if='selectList.length > 0'>批量删除</i-button>
        <i-button type="error" @click='newGWMadelShow'>上传资源</i-button>
      </ul>
    </Row>

    <section class='tabelContent'>
      <Tabs :value="listtabname" @on-click='switchFileType' style='margin-bottom:80px;padding-right:20px;'>
        <TabPane label="我的资源" name="weiyue">
          <tablePage border :queryData="queryData" :emitrow='emitrow' :randomrow='randomrow' :searchParam='searchParam'
            :issearch='issearch' @selectLcd='selectLcd'></tablePage>
        </TabPane>
        <TabPane label="公共资源" name="yiyue">
          <tablePage border :queryData="queryData" :emitrow='emitrow' :randomrow='randomrow' :searchParam='searchParam'
            :issearch='issearch' @selectLcd='selectLcd'></tablePage>

        </TabPane>



      </Tabs>
    </section>

    <Modal v-model="newGWMadel" title='上传资源'>
      <Form :model="newGWData" label-position="top">
        <FormItem label="文件名称">
          <Input v-model="newGWData.filename"></Input>
        </FormItem>
        <!-- <Row class=''>
                <Col span="11">
                    <FormItem label="文件类型" class=''>
                      <RadioGroup v-model="newGWData.filetype" @on-change='getAssesttype'>
                        <Radio label="0">图片</Radio>
                        <Radio label="1">音频</Radio>
                        <Radio label="2">视频</Radio>

                      </RadioGroup>
                    </FormItem>
                </Col>
                <Col span="2" style="text-align: center">&nbsp;</Col>
                 <Col span="11"> -->
        <FormItem label="存储">
          <RadioGroup v-model="newGWData.ispublic" @on-change='changepublic'>
            <Radio label="0">个人资源</Radio>
            <Radio label="1">公共库</Radio>
          </RadioGroup>
        </FormItem>
        <!--     </Col>
              </Row> -->

        <FormItem label="图片水印" class=''>
          <RadioGroup v-model="picwater" @on-change='changepicwater'>
            <Radio label="0">开启</Radio>
            <Radio label="1">关闭</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="上传">
          <Upload ref="upload" type="drag" :max-size="2048000" :on-error='fileFAIL' :on-success='fileSUccess'
            :on-exceeded-size="handleMaxSize" :before-upload='beforeload' :action="actionUrl">
            <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>点击或拖拽文件到这里上传</p>
            </div>
          </Upload>
        </FormItem>
        <p v-if='hadposter == 2' style='color:orangered'>请继续上传视频播放封面图片</p>
      </Form>
      <div slot="footer">

        <p class='exp'>可上传图片、视频、音频。</p>
        <Button type="default" @click='newGWMadel = false' icon="md-close">取消</Button>
        <Button type="info" @click='postNewGW' icon="md-checkmark-circle-outline" :disabled='disbtn'>提交</Button>

      </div>
    </Modal>

  </section>
</template>

<script>
import getDates from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
export default {
  name: 'noticelist',
  components: {
    tablePage,
    bemodal,
  },
  data () {
    return {
      picwater: '0',
      selectList: [],
      edit: false,
      ispdsearch: -1,
      listtabname: 'weiyue',// tab切换name
      reloadpdTmep: -1,
      reloadTmep: -1,
      initformData: [],
      curSonItem: {},
      initformpdData: [],
      formData: [
        ['media/getId', 'media/save', 'media/delete'],
        [{
          type: 'input',
          title: '标题',
          name: 'title',
          model: '',
        },
        {
          type: 'datetime',
          title: '结束时间',
          name: 'endtime',
          model: '',
          block: true,
        },
        {
          type: 'datetime',
          title: '开始时间',
          name: 'begintime',
          model: '',
          block: true,
        },
        {
          type: 'input',
          title: '超链接',
          name: 'url',
          model: '',
        },
        {
          type: 'numberInput',
          title: '排序',
          name: 'sort',
          model: 1,
        },
        {
          type: 'uploadimg',
          title: '背景图',
          name: 'pic',
          pictype: {
            type: 'videobg',
            size: '16:9'
          },
          model: '',

        },
        {
          type: 'hidden',
          children: [{
            name: 'guid',
            model: ''
          }]
        }
        ]
      ],
      queryData: ['media/getQueryList',
        [{
          type: 'selection',
          width: 60,
          align: 'center'
        }, {
          title: '资源',
          key: '',
          width: 150,
          render: (h, params) => {


            var styles = {//设置样式
              display: 'inline-block',
              width: '100px',
              height: '60px',
              borderRadius: '3px',
              textAlign: 'center',
              lineHeight: '60px',
              marginRight: '3px'
            }
            var _filetype = params.row.url.split('.')
            var _type = this.getfiletype(_filetype[_filetype.length - 1])
            if (_type == 0) {
              var _pics = params.row.url.split(',')
              var imgs = []
              _pics.map(function (val, index) {
                imgs.push(h('img', { style: styles, attrs: { src: val } }))
              })

              return h('viewer', imgs)
            } else {
              if (_type == '2') {
                var _videourl = params.row.url.split('&')[1]
                var _poster = params.row.url.split('&')[0]
                return h('video', { style: { width: '150px', height: '100px' }, attrs: { controls: "controls", poster: _poster } }, [h('source', { style: { width: '50px', height: '50px' }, attrs: { src: _videourl } })])
              } else {
                return h('video', { style: { width: '150px', height: '100px' }, attrs: { controls: "controls" } }, [h('source', { style: { width: '50px', height: '50px' }, attrs: { src: params.row.url } })])
              }

            }


          }

        },
        {
          title: '文件地址',
          key: 'url',

          align: 'center',
        },
        {
          title: '添加人',
          width: 100,
          key: 'addusername',
          align: 'center',
        },
        {
          title: '添加时间',
          key: 'addtime',
          width: 150,
          align: 'center',
        }
        ]
      ],
      searchParam: {
        title: '',
        ispublic: 0,
      },
      issearch: -1,
      curIndex: 0,
      emitrow: {},
      randomrow: -1,
      newGWMadel: false,
      newGWData: {
        filename: '',
        filetype: '0',
        ispublic: '0',
        guid: '',
        url: '',
      },
      disbtn: true,
      actionUrl: '',
      hadposter: 0,
      hadposterurl: '',
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    this.actionUrl = this.baseURL.imgURL

  },
  methods: {
    removeAll () {

      var datalist = this.selectList
      var that = this
      var arr = []
      datalist.map(function (val, index) {
        arr.push(val['guid'])
      })
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否删除选中的' + this.selectList.length + '条资源  ？</p>',
        onOk: () => {
          arr.map(function (val, index) {
            var param = {
              id: val,
            }
            console.log(param, 'param')
            that.axios.post('media/delete', param).then(res => {
              ////console.log(res)
              if (index == arr.length - 1) {
                that.$Message.success(res.msg)
                that.reloadTable()
                that.selectList = []
              }



            }).catch(function (res) {
              that.$Message.error('未知问题')
            })
          })

        },
        onCancel: () => {

        }
      })
    },
    beforeload (a, b, c) {
      var deferred = $.Deferred();
      var that = this
      var _url = a.name.split('.')
      var newurl = _url[_url.length - 1]
      var filetype = getfiletype(newurl)
      if (filetype == 0) {

        if (this.picwater == '0') {
          that.actionUrl = 'https://app.wjdaily.com:9907/UploadImageServlet?ispress=&iscopy=1&notkeeppic=&maxW=1080&iswater=1'
        } else {
          that.actionUrl = 'https://app.wjdaily.com:9907/UploadImageServlet?ispress=&iscopy=1&notkeeppic=&maxW=1080'
        }
      } else {
        that.actionUrl = this.baseURL.imgURL
      }
      this.$nextTick(() => {
        deferred.resolve();
      });
      return deferred
      function getfiletype (ext) {
        if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1) {
          return 0
        } else if (['mp4', 'mu38', 'm4v'].indexOf(ext.toLowerCase()) !== -1) {
          return 2
        } else if (['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1) {
          return 1
        }

      }
    },
    changepicwater (e) {
      console.log(e)
      this.picwater = String(e)
    },
    switchFileType (name) {


      if (name == 'weiyue') {
        this.newGWData.ispublic = '0'
        this.searchParam.ispublic = '0'
        this.searchData()

      } else if (name == 'yiyue') {
        this.newGWData.ispublic = '1'
        this.searchParam.ispublic = '1'
        this.searchData()

      } else {
        this.searchData()

      }
    },
    changepublic (e) {
      console.log(e, 'e')
      this.searchParam.ispublic = e
      this.searchData()
      if (e == 0) {
        this.listtabname = 'weiyue'
      } else {
        this.listtabname = 'yiyue'
      }
    },
    selectLcd (a) {
      console.log(a)
      this.selectList = a
    },
    fileFAIL () {
      this.$Message.error('文件上传失败')
    },
    fileSUccess (a, b, c) {
      console.log(a, b, c)
      console.log(a.url)
      var _url = a.url.split('.')
      var newurl = _url[_url.length - 1]

      var tupian = this.getfiletype(newurl)
      this.hadposter = tupian
      if (tupian != 2) {
        this.disbtn = false
      } else {
        this.hadposterurl = a.url
      }

    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: '超出文件大小限制',
        desc: '文件 ' + file.name + ' 太大，不能超过 2G。'
      });
    },
    newGWMadelShow () {
      this.$refs.upload.clearFiles()
      this.newGWMadel = true
    },
    postNewGW () {

      var uploadlist = this.$refs.upload.fileList
      console.log(uploadlist)
      var that = this

      if (uploadlist.length > 0) {
        var filelist = uploadlist
        var pic = ''
        filelist.map(function (val, index) {
          pic += val['response']['url']
        })
        this.newGWData.url = pic

      } else {
        this.$Message.warning('请上传资源')
        return false;
      }
      if (that.newGWData.url.indexOf('mp4') > -1) {
        var url = that.newGWData.url.split('.mp4')
        that.newGWData.url = url[1] + '&' + url[0] + '.mp4'
      }
      if (that.newGWData.url.indexOf('m4v') > -1) {
        var url = that.newGWData.url.split('.m4v')
        that.newGWData.url = url[1] + '&' + url[0] + '.m4v'
      }
      var _url = that.newGWData.url.split('.')
      var newurl = _url[_url.length - 1]
      var tupian = that.getfiletype(newurl)
      this.newGWData.filetype = tupian
      this.newGWData.time = this.getCurDate()
      this.assestType = String(this.newGWData.filetype)
      if (this.newGWData.filename == '') {
        this.$Message.warning('请填写资源名称')
        return false;
      }
      this.axios.post('media/save', this.newGWData).then(res => {
        console.log(res)

        var name = ['weiyue', 'yiyue']

        that.switchFileType(name[that.newGWData.ispublic])

        that.newGWMadel = false
        that.newGWData = {
          filename: '',
          filetype: '0',
          ispublic: '0',
          guid: '',
          url: '',
        }
      })
    },
    getCurDate () {

      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
        + " " + date.getHours() + seperator2 + date.getMinutes()
        + seperator2 + date.getSeconds();
      return currentdate;

    },
    searchData () {
      this.issearch = Math.random()
    },
    getfiletype (ext) {
      if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1) {
        return 0
      } else if (['mp4', 'mu38', 'm4v'].indexOf(ext.toLowerCase()) !== -1) {
        return 2
      } else if (['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1) {
        return 1
      }

    },


    reloadpdTable () {
      this.ispdsearch = Math.random()
    },
    reloadTable () {
      this.issearch = Math.random()
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
}

.demo-upload-list {
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
  margin-right: 0px;
}

#pdData {
  display: flex;
  justify-content: flex-start;
}

.itempd {

  height: 32px;
  line-height: 32px;
  border-radius: 20px;
  padding: 0 15px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer
}

.itempd.active {
  background-color: #00d186;
  border-color: #00d186;
  color: #fff;
}

.newPDvideo {
  text-align: right;
  margin: 0px 0px 20px;
}

.exp {
  float: left;
  line-height: 30px;
}
</style>
